import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Row, } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { ErrorMessage, Field, FieldArray, } from 'formik';
import { BiTrash } from 'react-icons/bi';
import { VscDiffAdded } from 'react-icons/vsc';
import { handleNumericDot } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import Swal from 'sweetalert2';

export default function TET(props) {
    const { Formik, tetGetData } = props;
    useEffect(() => {
        if (Formik.values.isTet === "Yes" && tetGetData?.length > 0) {
            tetGetData?.forEach((data, index) => {
                
                getCandidTetScore(data?.hall_ticket,data?.tet_type, index);
                Formik.setFieldValue(`tet[${index}]`, {
                    nameInTet: data?.name_in_tet || "",
                    hallTicket: data?.hall_ticket || "",
                    paper: data?.paper || "",
                    yearOfPass: data?.year_of_pass || "",
                    tetType: data?.tet_type || "",
                    marks: data?.marks || "",
                });
            });
        } else {
            Formik.setFieldValue("tet", [
                {
                    paper: "",
                    hallTicket: "",
                    yearOfPass: "",
                    tetType: "",
                    marks: "",
                    nameInTet: "",
                },
            ]);
        }
    }, [tetGetData]);
// useEffect(() => {
//     if (Formik.values.isTet === "Yes" && tetGetData?.length > 0) {

//         const formattedData = tetGetData.map((data) => ({
//             nameInTet: data?.name_in_tet || "",
//             hallTicket: data?.hall_ticket || "",
//             paper: data?.paper || "",
//             yearOfPass: data?.year_of_pass || "",
//             tetType: data?.tet_type || "",
//             marks: data?.marks || "",
//         }));

//         Formik.setFieldValue("tet", formattedData);

//     } else {

//         Formik.setFieldValue("tet", [
//             {
//                 paper: "",
//                 hallTicket: "",
//                 yearOfPass: "",
//                 tetType: "",
//                 marks: "",
//                 nameInTet: "",
//             },
//         ]);
//     }

// }, [tetGetData]);

    const [invalidShown, setInvalidShown] = useState({});
    const [showPaperDtls, setPaperDtls] = useState({});
    const invalidShownRef = useRef({});
    const [showTetDtls, setTetDtls] = useState([])
    function getCandidTetScore(hallNo,tetType, index) {
        // console.log("hallno 2 >>>",hallNo);
        let url = config.url.CONTEXT_READ_URL + "get-candidate-tet-score?htNo=" + hallNo;
        if (tetType === "APTET" && hallNo?.length > 0) {
            // console.log("tettype 3 >>>>",tetType ,"ht>>>>",hallNo, hallNo?.length)
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.status === true) {
                    setTetDtls(res?.data?.data)
                    const tetData = res?.data?.data || [];

// Check invalid hallticket
// const hasInvalidPaper = tetData.some(
//     (item) => item?.tet_subject?.startsWith("paper_1_a")
// );

// if (
//     hasInvalidPaper &&
//     Formik.values.tet[index]?.hallTicket &&
//     !invalidShownRef.current[index]
// ) {

//     invalidShownRef.current[index] = true;
//     Formik.setFieldValue(`tet[${index}].hallTicket`, "");
//     Formik.setFieldValue(`tet[${index}].paper`, "");
//     Formik.setFieldValue(`tet[${index}].tetType`, "");

//     Sweetalert(
//         "Invalid Hall Ticket Number for Paper 2A.",
//         "warning"
//     );

//     return;
// }

setTetDtls(tetData);

let options = tetData.map((ds, i) => (
    <option key={i} value={ds?.tet_subject}>
        {ds?.tet_post_name}
    </option>
));

setPaperDtls((prevState) => ({
    ...prevState,
    [index]: options,
}));
                    // let options = res?.data?.data?.map((ds, i) => (
                    //     <option key={i} value={ds?.tet_subject}>{ds?.tet_post_name}</option>
                    // ));
                    setPaperDtls((prevState) => ({
                        ...prevState,
                        [index]: options,
                    }));
                }
                else if (res?.data?.status === false) {
                    Formik.setFieldValue(`tet[${index}].hallTicket`, '')
                    Sweetalert('No Tet Details Found', 'warning'); setTetDtls([]);
                    setPaperDtls({});
                }
                else {
                    Sweetalert('Invalid Hall Ticket Number', 'warning'); setTetDtls([]);
                    setPaperDtls({});
                }
            })
        }
        else {
            // Sweetalert("")
        }
    }
    function checkDuplicateHallTicketAndPaper(index, hallTicket, paper) {
        const allEntries = Formik.values.tet;
        // Normalize to uppercase and trimmed values for consistency
        const currentHall = hallTicket?.trim()?.toUpperCase();
        const currentPaper = paper?.trim()?.toUpperCase();

        // Check if same hallticket+paper combination exists at a different index
        return allEntries.some((entry, i) => {
            if (i !== index) {
                return (
                    entry.hallTicket?.trim()?.toUpperCase() === currentHall &&
                    entry.paper?.trim()?.toUpperCase() === currentPaper
                );
            }
            return false;
        });
    }

    return (
        <div className="personal-block mb-2">

            <div className="personal-head">
                <span>APTET/CENTRAL TET DETAILS (CTET)</span>
            </div>
            <div className="personal-row mb-2">

                <div className="table-responsive px-3 mb-3" >

                    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                        style={{ borderCollapse: 'collapse', }}>
                        <thead>
                            <tr>
                                <td> <Form.Label className="input-lable mb-2">TET Type</Form.Label></td>
                                <td><Form.Label className="input-lable mb-2">HallTicket No.</Form.Label></td>
                                <td> <Form.Label className="input-lable mb-2">Paper</Form.Label></td>
                                {/* {Formik.values.tet[index]?.tetType === "APTET" && */}
                                <td> <Form.Label className="input-lable mb-2">Name In TET</Form.Label></td>
                                {/* } */}

                                <td><Form.Label className="input-lable mb-2">Year of Passing </Form.Label></td>
                                <td><Form.Label className="input-lable mb-2">Marks</Form.Label></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <FieldArray name="tet">
                                {(formikFieldArray) => {
                                    return formikFieldArray.form.values.tet?.map((experienceDetails, index) => {
                                        return (<tr key={index}>
                                            <td>
                                                <div className="input-div position-relative">
                                                    <Form.Group >
                                                        <Field as="select"
                                                            className="input-field form-control"
                                                            name={`tet[${index}].tetType`}
                                                            onChange={() => {
                                                                Formik.setFieldValue(`tet[${index}].yearOfPass`, "");
                                                                Formik.setFieldValue(`tet[${index}].hallTicket`, "");
                                                                Formik.setFieldValue(`tet[${index}].marks`, "");
                                                                Formik.setFieldValue(`tet[${index}].paper`, "");
                                                                Formik.setFieldValue(`tet[${index}].nameInTet`, "");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="APTET">AP TET</option>
                                                            <option value="CTET">CTET</option>

                                                        </Field>
                                                        <ErrorMessage name={`tet[${index}].tetType`} component="div" className="text-error" />
                                                    </Form.Group>
                                                    <IoIosArrowDown className="dropdown-icon" />
                                                </div>
                                            </td>
                                            <td>
                                                <Form.Group>
                                                    <Field type="text" name={`tet[${index}].hallTicket`} className="input-field form-control" maxLength="15"
                                                        onBlur={(e) => {
                                                            const value = e.target.value;
                                                             let tet_type = Formik?.values?.tet[index]?.tetType
                                                            getCandidTetScore(value,tet_type, index);
                                                        }}
                                                        onChange={(e) => {

        setInvalidShown((prev) => ({
            ...prev,
            [index]: false,
        }));
        invalidShownRef.current[index] = false;
        Formik.setFieldValue(
            `tet[${index}].hallTicket`,
            e.target.value
        );

        Formik.setFieldValue(`tet[${index}].paper`, '');
        Formik.setFieldValue(`tet[${index}].nameInTet`, '');
        Formik.setFieldValue(`tet[${index}].fatherName`, '');
        Formik.setFieldValue(`tet[${index}].marks`, '');
        Formik.setFieldValue(`tet[${index}].yearOfPass`, '');
    }}
                                                    />
                                                    <ErrorMessage name={`tet[${index}].hallTicket`} component="div" className="text-error" />
                                                </Form.Group>
                                            </td>
                                            {/* <td>
                                                <div className="input-div position-relative">
                                                    <Form.Group>
                                                        <Field as="select" className="input-field form-control"
                                                            name={`tet[${index}].paper`}

                                                            onChange={(e) => {
                                                                let paper = e.target.value;
                                                                let hallTicket = Formik.values.tet[index]?.hallTicket;

                                                                if (checkDuplicateHallTicketAndPaper(index, hallTicket, paper)) {
                                                                    Swal.fire({
                                                                        text: "Duplicate Entry: Same Hall Ticket and Paper already exist!",
                                                                        icon: "warning",
                                                                        backdrop: true,
                                                                        allowOutsideClick: false,

                                                                        allowEscapeKey: false,
                                                                        didOpen: () => {
                                                                            const swalModal = Swal.getPopup();
                                                                            if (swalModal) {
                                                                                swalModal.setAttribute("tabindex", "0");
                                                                                swalModal.focus();
                                                                            }
                                                                        },
                                                                    }).then((update) => {

                                                                        if (update.isConfirmed) {
                                                                            Formik.setFieldValue(`tet[${index}].paper`, "");
                                                                        }
                                                                    })
                                                                  
                                                                    return;
                                                                }

                                                                let data = showTetDtls?.filter((val) => val?.tet_subject === paper);
                                                                if (data?.length > 0) {
                                                                    Formik.setFieldValue(`tet[${index}].nameInTet`, data[0]?.candidate_name);
                                                                    Formik.setFieldValue(`tet[${index}].fatherName`, data[0]?.father_name);
                                                                    Formik.setFieldValue(`tet[${index}].marks`, data[0]?.score);
                                                                    Formik.setFieldValue(`tet[${index}].yearOfPass`, data[0]?.yop);
                                                                } else {
                                                                    Formik.setFieldValue(`tet[${index}].nameInTet`, "");
                                                                    Formik.setFieldValue(`tet[${index}].fatherName`, "");
                                                                    Formik.setFieldValue(`tet[${index}].marks`, "");
                                                                    Formik.setFieldValue(`tet[${index}].yearOfPass`, "");
                                                                }

                                                            }}>
                                                            <option value="">Select</option>
                                                            {Formik?.values?.tet[index]?.tetType === 'APTET' &&
                                                             showPaperDtls[index]
                                                             }
                                                            {Formik?.values?.tet[index]?.tetType === 'CTET' &&
                                                                <><option value='Paper 1A'>Paper 1(A)</option>
                                                                    <option value='Paper 1B'>Paper 1(B)</option>
                                                                    <option value='Paper 2A'>Paper 2(A)</option>
                                                                    <option value='Paper 2B'>Paper 2(B)</option> </>}
                                                        </Field>
                                                        <ErrorMessage name={`tet[${index}].paper`} component="div" className="text-error" />
                                                    </Form.Group>
                                                    <IoIosArrowDown className="dropdown-icon" />
                                                </div>
                                            </td> */}
                                            <td>
  <div className="input-div position-relative">
    <Form.Group>
      <Field
        as="select"
        className="input-field form-control"
        name={`tet[${index}].paper`}
        onChange={(e) => {
          let paper = e.target.value;
          let hallTicket = Formik.values.tet[index]?.hallTicket;

          if (checkDuplicateHallTicketAndPaper(index, hallTicket, paper)) {
            Swal.fire({
              text: "Duplicate Entry: Same Hall Ticket and Paper already exist!",
              icon: "warning",
              backdrop: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                const swalModal = Swal.getPopup();
                if (swalModal) {
                  swalModal.setAttribute("tabindex", "0");
                  swalModal.focus();
                }
              },
            }).then((update) => {
              if (update.isConfirmed) {
                Formik.setFieldValue(`tet[${index}].paper`, "");
              }
            });

            return;
          }

          let data = showTetDtls?.filter(
            (val) => val?.tet_subject === paper
          );

          if (data?.length > 0) {
            Formik.setFieldValue(
              `tet[${index}].nameInTet`,
              data[0]?.candidate_name
            );
            Formik.setFieldValue(
              `tet[${index}].fatherName`,
              data[0]?.father_name
            );
            Formik.setFieldValue(
              `tet[${index}].marks`,
              data[0]?.score
            );
            Formik.setFieldValue(
              `tet[${index}].yearOfPass`,
              data[0]?.yop
            );
          } else {
            Formik.setFieldValue(`tet[${index}].nameInTet`, "");
            Formik.setFieldValue(`tet[${index}].fatherName`, "");
            Formik.setFieldValue(`tet[${index}].marks`, "");
            Formik.setFieldValue(`tet[${index}].yearOfPass`, "");
          }
        }}
      >
        <option value="">Select</option>

        {/* {Formik?.values?.tet[index]?.tetType === "APTET" &&
          [...new Map(
            showTetDtls
              ?.filter((item) =>
                item?.tet_subject?.startsWith("paper_2_a")
              )
              ?.map((item) => [item.tet_subject, item])
          ).values()].map((item, i) => (
            <option key={i} value={item?.tet_subject}>
              {item?.tet_post_name}
            </option>
          ))} */}
{Formik?.values?.tet[index]?.tetType === "APTET" &&
  [...new Map(
    showTetDtls
      ?.filter((item) =>
        item?.tet_subject?.startsWith("paper_2_a")
      )
      ?.map((item) => [item.tet_subject, item])
  ).values()].map((item, i) => (
    <option key={i} value={item?.tet_subject}>
      {item?.tet_post_name}
    </option>
))}

{Formik?.values?.tet[index]?.tetType === "CTET" && (
<>
<option value="paper_2_a_english">PAPER - II- A ( Language Teachers-ENGLISH )</option>
<option value="paper_2_a_hindi">PAPER - II- A ( Language Teachers-HINDI )</option>
<option value="paper_2_a_kannada">PAPER - II- A ( Language Teachers-KANNADA )</option>
<option value="paper_2_a_oriya">PAPER - II- A ( Language Teachers-ORIYA )</option>
<option value="paper_2_a_sanskrit">PAPER - II- A ( Language Teachers-SANSKRIT )</option>
<option value="paper_2_a_tamil">PAPER - II- A ( Language Teachers-TAMIL )</option>
<option value="paper_2_a_telugu">PAPER - II- A ( Language Teachers-TELUGU )</option>
<option value="paper_2_a_urdu">PAPER - II- A ( Language Teachers-URDU )</option>
<option value="paper_2_a_maths_science">PAPER - II- A ( Mathematics and Sciences )</option>
<option value="paper_2_a_social_studies">PAPER - II- A ( Social Studies )</option>
 </>)}</Field>

 <ErrorMessage
        name={`tet[${index}].paper`}
        component="div"
        className="text-error"
      />
    </Form.Group>

    <IoIosArrowDown className="dropdown-icon" />
  </div>
</td>
                                            <td>
                                                <Form.Group>
                                                    {Formik?.values?.tet[index]?.tetType === 'APTET' && <div>{Formik?.values?.tet[index]?.nameInTet}</div>}
                                                    {Formik?.values?.tet[index]?.tetType === 'CTET' &&
                                                        <div>
                                                            <Field type="text" name={`tet[${index}].nameInTet`} className="input-field form-control" />
                                                            <ErrorMessage name={`tet[${index}].nameInTet`} component="div" className="text-error" />
                                                        </div>}
                                                </Form.Group>
                                            </td>
                                            {/* } */}


                                            <td>
                                                <div className="input-div position-relative">
                                                    <Form.Group >
                                                        {Formik?.values?.tet[index]?.tetType === 'APTET' && <div>{Formik?.values?.tet[index]?.yearOfPass}</div>}
                                                        {Formik?.values?.tet[index]?.tetType === 'CTET' && <div>
                                                            <Field as="select" className="input-field form-control" name={`tet[${index}].yearOfPass`}>
                                                                <option value="">Select</option>
                                                                <option value="2011">2011</option>
                                                                <option value="2012">2012</option>
                                                                <option value="2013">2013</option>
                                                                <option value="2014">2014</option>
                                                                <option value="2015">2015</option>
                                                                <option value="2016">2016</option>
                                                                <option value="2017">2017</option>
                                                                <option value="2018">2018</option>
                                                                <option value="2019">2019</option>
                                                                <option value="2020">2020</option>
                                                                <option value="2021">2021</option>
                                                                <option value="2022">2022</option>
                                                                <option value="2023">2023</option>
                                                                <option value="2024">2024</option>

                                                            </Field>
                                                        </div>}

                                                        <ErrorMessage name={`tet[${index}].yearOfPass`} component="div" className="text-error" />
                                                    </Form.Group>
                                                    <IoIosArrowDown className="dropdown-icon" />
                                                </div>
                                            </td>

                                            <td>
                                                <Form.Group>
                                                    {Formik?.values?.tet[index]?.tetType === 'APTET' && <div>{Formik?.values?.tet[index]?.marks}</div>}
                                                    {Formik?.values?.tet[index]?.tetType === 'CTET' && <div>
                                                        <Field type="text" name={`tet[${index}].marks`} className="input-field form-control"
                                                            onKeyPress={(e) => { handleNumericDot(e) }} maxLength="8" />
                                                    </div>}
                                                    <ErrorMessage name={`tet[${index}].marks`} component="div" className="text-error" />

                                                </Form.Group>
                                            </td>
                                            <td className='text-end'>

                                                {(Formik.values.tet.length >= 2) ? (<>
                                                    <button type="button" className="button-titile btn btn-sm btn-danger mb-2" onClick={() => formikFieldArray.remove(index)}>
                                                        <BiTrash style={{ fontSize: "20px" }}></BiTrash></button>
                                                </>) : ("")}
                                            </td>
                                        </tr>);
                                    });
                                }}
                            </FieldArray>
                        </tbody>
                        <tfoot>
                            {Formik?.values?.tet?.length <= 3 && (
                                <tr>
                                    <td className='text-end' colSpan={7} >
                                        <FieldArray name="tet">
                                            {(formikFieldArray) => (
                                                <button type="button" className="button-titile btn btn-sm btn-success mb-2 btn-end"
                                                    onClick={() => formikFieldArray.push({
                                                        paper: "",
                                                        yearOfPass: "",
                                                        hallTicket: ""
                                                    })}
                                                ><VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded></button>
                                            )}
                                        </FieldArray>
                                    </td>
                                </tr>)}
                        </tfoot>
                    </table>
                </div>
            </div>

        </div>
    )
}
